import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Notes API
export const notesApi = {
  getAll: (params = {}) => axios.get(`${API}/notes`, { params }),
  getOne: (id) => axios.get(`${API}/notes/${id}`),
  create: (data) => axios.post(`${API}/notes`, data),
  update: (id, data) => axios.put(`${API}/notes/${id}`, data),
  createAudio: (formData) => axios.post(`${API}/notes/audio`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  createVideo: (formData) => axios.post(`${API}/notes/video`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => axios.delete(`${API}/notes/${id}`)
};

// Chat API
export const chatApi = {
  send: (message, conversationHistory = [], sessionId = null) =>
    axios.post(`${API}/chat`, { message, conversation_history: conversationHistory, session_id: sessionId }),
  getSessions: (params = {}) => axios.get(`${API}/chat/sessions`, { params }),
  getSession: (sessionId) => axios.get(`${API}/chat/sessions/${sessionId}`),
  deleteSession: (sessionId) => axios.delete(`${API}/chat/sessions/${sessionId}`),
};

// Insights API
export const insightsApi = {
  getAll: () => axios.get(`${API}/insights`)
};

// Analytics API
export const analyticsApi = {
  get: () => axios.get(`${API}/analytics`)
};

// Moods API
export const moodsApi = {
  create: (data) => axios.post(`${API}/moods`, data),
  update: (id, data) => axios.put(`${API}/moods/${id}`, data),
  getAll: (params = {}) => axios.get(`${API}/moods`, { params }),
  getToday: () => axios.get(`${API}/moods/today`),
  getAnalytics: () => axios.get(`${API}/moods/analytics`),
  getWeeklyReport: () => axios.get(`${API}/moods/weekly-report`),
};

// Preferences API
export const preferencesApi = {
  get: () => axios.get(`${API}/preferences`),
  update: (data) => axios.put(`${API}/preferences`, data),
};

// Services API
export const servicesApi = {
  getStatus: () => axios.get(`${API}/services/status`),
  connect: (serviceId) => axios.post(`${API}/services/${serviceId}/connect`),
  callback: (serviceId, data) => axios.post(`${API}/services/${serviceId}/callback`, data),
  disconnect: (serviceId) => axios.post(`${API}/services/${serviceId}/disconnect`),
};

// Beta Signup API
export const betaApi = {
  signup: (email, name) => axios.post(`${API}/beta-signup`, { email, name })
};

export default {
  notes: notesApi,
  chat: chatApi,
  insights: insightsApi,
  analytics: analyticsApi,
  moods: moodsApi,
  preferences: preferencesApi,
  services: servicesApi,
  beta: betaApi
};
